export namespace StartupUtils {
    export let GetUserLanguage = () => {
        const supportedLanguage = ['en', 'it', 'de'];

        try {
            const lang = window.navigator.language.substring(0, 2);
            if (supportedLanguage.find(p => p === lang) === undefined) {
                return 'en';
            }
            return lang;
        } catch (exc) {
            return 'en';
        }
    };
}